import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {ConnectionRequestType, IConnection, IConnectionRequest} from '../incase-domain/connection';
import {IPaginatedResult, IPaginatedResultWrapper, IPaginatedSearch} from '../incase-domain/search';
import {fetchConnectionRequests, fetchConnections} from '../service/connection.service';
import {QUERY_KEYS} from '../utils/queryKeys';

export function useConnectionsPaginatedQuery(
    paginatedSearch: IPaginatedSearch,
    options?: {
        enabled?: boolean;
        staleTime?: number;
        keepPreviousData?: boolean;
        refetchOnWindowFocus?: boolean;
    }
): UseQueryResult<IPaginatedResult<IConnection>> {
    return useQuery(QUERY_KEYS.connection.list(paginatedSearch), () => fetchConnections(paginatedSearch), {
        keepPreviousData: true,
        ...options,
    });
}

export function useConnectionRequestsPaginatedQuery(
    requestType: ConnectionRequestType,
    paginatedSearch: IPaginatedSearch,
    options?: {
        enabled?: boolean;
        staleTime?: number;
        keepPreviousData?: boolean;
        refetchOnWindowFocus?: boolean;
    }
): UseQueryResult<IPaginatedResult<IConnectionRequest>> {
    const queryKey =
        requestType === ConnectionRequestType.RECEIVED
            ? QUERY_KEYS.connection.received(paginatedSearch)
            : QUERY_KEYS.connection.sent(paginatedSearch);

    return useQuery(queryKey, () => fetchConnectionRequests(requestType, paginatedSearch), {
        keepPreviousData: true,
        ...options,
    });
}

export function toPaginatedResultWrapper<T>(
    paginatedSearch: IPaginatedSearch,
    data: IPaginatedResult<T> | undefined,
    isFetching: boolean
): IPaginatedResultWrapper<T> {
    return {
        content: data?.content ?? [],
        pageNumber: data?.pageNumber ?? paginatedSearch.pageNumber,
        pageSize: data?.pageSize ?? paginatedSearch.pageSize,
        numberOfElements: data?.numberOfElements ?? 0,
        isFetching,
    };
}
